import { render } from "./phasePolyBoxInfo.vue?vue&type=template&id=62aa2d83"
import script from "./phasePolyBoxInfo.vue?vue&type=script&lang=js"
export * from "./phasePolyBoxInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__